import React from 'react';
import { TablePagination } from '@material-ui/core';

/**
 * Wrapper component to fix Material-UI deprecation warnings
 * Maps onChangePage -> onPageChange and onChangeRowsPerPage -> onRowsPerPageChange
 */
const MaterialTablePagination = (props) => {
  const {
    onChangePage,
    onChangeRowsPerPage,
    onPageChange,
    onRowsPerPageChange,
    ...otherProps
  } = props;

  // MaterialTable passes onChangePage and onChangeRowsPerPage (old prop names)
  // Material-UI v4+ requires onPageChange and onRowsPerPageChange (new prop names)
  // Map old to new if new ones are not provided
  const handlePageChange = onPageChange !== undefined ? onPageChange : onChangePage;
  const handleRowsPerPageChange = onRowsPerPageChange !== undefined ? onRowsPerPageChange : onChangeRowsPerPage;

  // Remove old prop names to avoid warnings
  const cleanProps = { ...otherProps };
  delete cleanProps.onChangePage;
  delete cleanProps.onChangeRowsPerPage;

  return (
    <TablePagination
      {...cleanProps}
      onPageChange={handlePageChange}
      onRowsPerPageChange={handleRowsPerPageChange}
    />
  );
};

export default MaterialTablePagination;

